import { ColumnConfig } from '@components/design/migrated/Table';
import React from 'react';
import { CategoryLeaderboardPg } from '@models/CategoryLeaderboard';
import { Filters, ShareType } from '@utils/pageConfig/Types';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import CategoryLeaderboardTableRow from '../category-leaderboard-table-row/CategoryLeaderboardTableRow';

interface Props {
  categoryLeaderboardPg: CategoryLeaderboardPg;
  columns: ColumnConfig[];
  sortedColumn: string;
  selectedGrowthType: GrowthTypes;
  countries: Filters;
  currencySymbol: string;
  selectedShareType: ShareType;
}

export const CategoryLeaderboardTableHead: React.FC<Props> = ({
  categoryLeaderboardPg,
  columns,
  sortedColumn,
  selectedGrowthType,
  countries,
  currencySymbol,
  selectedShareType,
}) => {
  return (
    <tbody>
      <CategoryLeaderboardTableRow
        key={'Total'}
        categoryLeaderboardPg={categoryLeaderboardPg}
        columns={columns}
        isStickyRow={true}
        sortedColumn={sortedColumn}
        selectedGrowthType={selectedGrowthType}
        countries={countries}
        currencySymbol={currencySymbol}
        selectedShareType={selectedShareType}
      />
    </tbody>
  );
};

export default CategoryLeaderboardTableHead;
